import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

// 列表
async function list(query) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${query.competitionId}/live_media`,
    method: 'GET',
    params: query
  })
}

// 插入
async function insert(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/live_media`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 删除
async function remove(params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/live_media/${params.id}`,
    method: 'DELETE'
  })
}

// 批量删除
async function removeBatch(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/live_media/batchRemove`,
    method: 'DELETE',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded '
    }
  })
}

// 审核
async function putWonderfulMomentAuditApi(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/live_media/${data.mediaId}/audit`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

// 批量审核
async function putWonderfulMomentBatchAuditApi(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/live_media/batchAudit`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

// 批量审核
async function putWonderfulMomentBatchTopApi(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/live_media/batchTop`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

export default {
  list,
  insert,
  remove,
  removeBatch,
  putWonderfulMomentAuditApi,
  putWonderfulMomentBatchAuditApi,
  putWonderfulMomentBatchTopApi
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-live-media.js